import { render, staticRenderFns } from "./ClassifyNameConfig.vue?vue&type=template&id=44ece065&scoped=true&"
import script from "./ClassifyNameConfig.vue?vue&type=script&lang=js&"
export * from "./ClassifyNameConfig.vue?vue&type=script&lang=js&"
import style0 from "./ClassifyNameConfig.vue?vue&type=style&index=0&id=44ece065&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ece065",
  null
  
)

export default component.exports